import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as instructorActions from '../../_actions/department.actions'
import { MultiSelect } from 'primereact/multiselect'

class Departments extends PureComponent {
    render() {
        return (
            <MultiSelect
                value={this.props.selectedDepartments || []}
                options={this.props.departments}
                onChange={(e) => this.props.handleChange(e.value)}
                placeholder="Select departments"
                filter
                className="w-full"
                maxSelectedLabels={3}
            />
        )
    }
}

function mapStateToProps(state) {
    return {
        departments: state.DepartmentReducer.departmentList,
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(instructorActions, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(Departments)
